import React from 'react';
import {  useSelector } from 'react-redux';
import { Skeletons } from 'ui/components/skeleton';

import CardJobs from './jobs.card';
import { ManifestDocument } from './manifest.documentation';

const initialState = {
  jobs: [],
};

export const SectionJobs = ({ manifest, loading, privilege, onJobsChange }) => {
  const [{ jobs }, setState] = React.useState(initialState);
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Manifest.Show']
  );
  const dummy = Array.from({ length: 10 }, (v, i) => i);

  React.useEffect(() => {
    if (!manifest) return;

    setState((prevState) => ({
      ...prevState,
      jobs: manifest?.jobs,
    }));
  }, [manifest]);

  return (
    <div className="p-0 p-md-3 ps-md-0 ">
      <div className="row">
        <div className="col-md-6 mb-3 mb-md-0">
          <div className="card legs rounded-2 bg-white">
            <div className="card-header-gray p-3 border-bottom">
              <h3 className="card-title dx-card-title m-0 p-0">
                Pengiriman
              </h3>
            </div>
            <div className="card-body p-0 position-relative">
              {loading || StateLoading ? (
                dummy?.map((d, i) => (
                  <div className="mb-3" key={i}>
                    <Skeletons height="30px" width="100%" />
                  </div>
                ))
              ) : (
                <div className="leg-list">
                  {jobs?.map((d, i) => (
                    <CardJobs
                      data={d}
                      keys={i + 1}
                      privilege={privilege}
                      manifest={manifest}
                      onJobsChange={onJobsChange}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6 mb-3 mb-md-0">
          <ManifestDocument
            manifest_id={manifest?.id}
            privilege={privilege}
          />
        </div>
      </div>
    </div>
  );
};
